import { Option } from "@/mk2/components/forms/SelectField";
import { localeCompare } from "@/mk2/helpers/sorting";
import { COUNTRIES_TO_PLACES, PLACES } from "@/mk/autogenerated/geoDataPlaces";

export function getPlaceIdForCountryId(countryId: number): number {
    return COUNTRIES_TO_PLACES[countryId.toString()];
}

export function getPlacesSelectOptionsForCounty(countyId: string): Option[] {
    return [{ value: "", label: "", isPlaceholder: true }].concat(
        PLACES.filter((place) => place[2].toString() === countyId)
            .sort((a, b) => localeCompare(a[1], b[1]))
            .map((p) => {
                return { value: p[0].toString(), label: p[1], isPlaceholder: false };
            }),
    );
}
